import { withApollo } from 'react-apollo';
import TimesheetActions from './TimesheetActions';

export default withApollo(TimesheetActions);
